import Root from "pages/root";
import styled from "@emotion/styled";
import React, { useLayoutEffect, useState } from "react";
import UI from "@mile-meeting/mile-ui";
import { useRecoilValue } from "recoil";
import { member } from "recoil/recoilState";
import { UserRole } from "utils/role";

interface ProtectedRouteProps {
  element: JSX.Element;
  page: string;
  accessRoles?: number[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, page, accessRoles }: ProtectedRouteProps) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const memberInfo = useRecoilValue(member);

  useLayoutEffect(() => {
    if (!(accessRoles && !accessRoles.includes(memberInfo?.role ?? UserRole.Staff))) {
      setIsAuthorized(true);
    }
  }, [memberInfo, accessRoles]);

  if (!isAuthorized) {
    return (
      <Container>
        <TitleContainer>
          <UI.Typography
            type="title03"
            fontStyle="bold"
            color="var(--alias-color-label-neutral)"
            style={{ padding: "24px 20px" }}
          >
            {page.split("/").pop()}
          </UI.Typography>
        </TitleContainer>
        {memberInfo && (
          <AlertContainer>
            <UI.Icon name="inform" color="var(--alias-color-status-negative)" size={20} />
            <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-status-negative)">
              해당 메뉴에 대한 접근 권한이 없습니다.
            </UI.Typography>
          </AlertContainer>
        )}
      </Container>
    );
  } else {
    return element;
  }
};

export default ProtectedRoute;

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 80px 20px;
  position: relative;
  min-width: 1140px;
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const AlertContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;
